import requests from "./httpService";

const GammaServices = {

  // ✅ Gamma Data
  getGammaData: async (product) => {
    return requests.get(`/gamma/today?product=${product}`);
  },

  // ✅ Vega Data
  getVegaData: async (product) => {
    return requests.get(`/vega/today?product=${product}`);
  },

};

export default GammaServices;
